import { render, staticRenderFns } from "./JourneyPausedOverlay.vue?vue&type=template&id=1b6ae6a8&scoped=true&"
import script from "./JourneyPausedOverlay.vue?vue&type=script&lang=js&"
export * from "./JourneyPausedOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ae6a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
